import React, { FC, PropsWithChildren } from 'react';
import { AuthStatus, useAuth } from 'services/authentication';

const RequireAuth: FC<PropsWithChildren> = ({ children }) => {
    const { status } = useAuth();

    if (status == AuthStatus.Error) {
        throw new Error('Authentication error');
    }

    if (status == AuthStatus.Unauthorized) {
        // Redirect to login page
        const refererLink = window.location.href.includes('flightaware.com')
            ? window.location.href
            : 'https://foresight.flightaware.com'; // fa_web session redirect will only work if referrer is a flightaware.com domain
        window.location.href = `https://login.flightaware.com/signin?redirect_uri=${encodeURIComponent(refererLink)}`;
        return null;
    }

    if (status == AuthStatus.Forbidden) {
        // Redirect to product page
        window.location.href = 'https://flightaware.com/commercial/foresight/';
        return null;
    }

    if (status == AuthStatus.Authorized) {
        return <>{children}</>;
    }

    throw new Error(`AuthStatus not supported: '${AuthStatus[status]}'`);
};

export default RequireAuth;
